import Component from '@ember/component';
import { computed, getProperties } from '@ember/object';
import { service } from '@ember/service';
import Highcharts from 'highcharts';

/*
  attrs
  - goalAmount
  - pledgedAmount
  - nonPledgedAmount
*/
export default Component.extend({
  formatAmountService: service(),

  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',

  totalAmount: computed('pledgedAmount', 'nonPledgedAmount', function () {
    return +this.pledgedAmount + +this.nonPledgedAmount;
  }),

  totalPercent: computed('pledgedAmount', 'goalAmount', function () {
    return Math.round((this.totalAmount * 100) / +this.goalAmount);
  }),

  pledgedPercent: computed('pledgedAmount', 'goalAmount', function () {
    let percent = (+this.pledgedAmount * 100) / +this.goalAmount;
    if (percent > 100) {
      percent = 100;
    } else if (percent < 0) {
      percent = 0;
    }
    return Math.round(percent);
  }),

  nonPledgedPercent: computed(
    'pledgedPercent',
    'nonPledgedAmount',
    'goalAmount',
    function () {
      let percent = (+this.nonPledgedAmount * 100) / +this.goalAmount;
      if (percent > 100) {
        percent = 100;
      } else if (percent + this.pledgedPercent > 100) {
        percent = 100 - this.pledgedPercent;
      } else if (percent < 0) {
        percent = 0;
      }
      return Math.round(percent);
    },
  ),

  chartSettings: computed(function () {
    let { pledgedPercent, nonPledgedPercent, totalPercent } = getProperties(
      this,
      'pledgedPercent',
      'nonPledgedPercent',
      'totalPercent',
    );
    let fillerPercentage = 100 - pledgedPercent - nonPledgedPercent;
    if (fillerPercentage < 0) {
      fillerPercentage = 0;
    }
    let formattedAmount = this.formatAmountService.format(this.totalAmount, {
      roundToDollar: true,
    });

    return {
      chart: {
        type: 'pie',
        spacing: [0, 0, 0, 0],
        height: 164,
      },
      title: {
        text: `<span>${totalPercent}%</span><div style='font-size: 1rem; color: #636c72'>${formattedAmount}</div>`,
        align: 'center',
        verticalAlign: 'middle',
        useHTML: true,
        style: {
          fontSize: '2rem',
          color: '#0b68a1',
          fontFamily: this.fontFamily,
        },
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          shadow: false,
          center: ['50%', '50%'],
        },
      },
      series: [
        {
          size: '100%',
          innerSize: '90%',
          dataLabels: {
            enabled: false,
          },
          data: [
            {
              name: 'Pledged Percentage',
              y: pledgedPercent,
              color: '#0b68a1',
              tooltip: {},
            },
            {
              name: 'Non-Pledged Percentage',
              y: nonPledgedPercent,
              color: '#3aacf2',
            },
            {
              y: fillerPercentage,
              color: '#eceeef',
            },
          ],
        },
      ],
    };
  }),

  didInsertElement() {
    this._super(...arguments);
    setTimeout(() => {
      Highcharts.chart(this.element, this.chartSettings);
    }, 0);
  },
});
